module.exports = __webpack_public_path__ + "r-v3/img/camera_none.a0b5945e.svg";